import React from 'react'
import { FormattedMessage } from 'react-intl'

import PingPongButton from '../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../utils/ping-pong-button-type.enum.ts'

const BookingDeclinedByUserAdminFooter = () => {
  return (
    <div className='flex w-full flex-col gap-3'>
      <PingPongButton
        label={
          <FormattedMessage
            id='ui.BookingDeclinedByUserAdminFooter.declinedByUserAdmin'
            defaultMessage='Séjour refusé par l’administrateur'
          />
        }
        type={PingPongButtonTypeEnum.DECLINED_BY_USER_ADMIN}
      />
    </div>
  )
}

export default BookingDeclinedByUserAdminFooter
